export default "__VITE_ASSET__Dgsa10Jp__"